module.exports = __webpack_public_path__ + "img/image25.75c79457.png";